"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeChannel = void 0;
const types_1 = require("./types");
exports.RealtimeChannel = (transport, target) => {
    const transportChannel = transport.getChannel(target);
    const subscribe = (event, onMessage) => {
        const handlers = transportChannel.subscribe(event, (unverifiedMessage) => {
            const decoded = types_1.Message.decode(unverifiedMessage);
            if (decoded._tag === 'Left') {
                return;
            }
            const message = decoded.right;
            if (message.event === event) {
                onMessage(message);
            }
        });
        return handlers;
    };
    const publish = async (message) => {
        await transportChannel.publish(message);
    };
    const leave = async () => {
        await transportChannel.leave();
    };
    const getInfo = transportChannel.getInfo;
    return {
        subscribe,
        publish,
        leave,
        getInfo,
    };
};
